import { startOfDay } from './format';
import type { Visit } from './types';

export type RangeKey = 'today' | 'yesterday' | '7d' | '30d' | 'custom';

export const RANGE_OPTIONS: { key: RangeKey; label: string }[] = [
  { key: 'today', label: '今日' },
  { key: 'yesterday', label: '昨日' },
  { key: '7d', label: '最近7天' },
  { key: '30d', label: '最近30天' },
  { key: 'custom', label: '自定义' },
];

export type DateBounds = {
  from: Date;
  to: Date;
};

export type CustomDates = {
  from: string;
  to: string;
};

export function parseLocalDate(ymd: string): Date {
  const [y, m, d] = ymd.split('-').map(Number);
  if (!y || !m || !d) return startOfDay();
  return new Date(y, m - 1, d);
}

export function toInputDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function defaultCustomDates(now = new Date()): CustomDates {
  const to = startOfDay(now);
  const from = new Date(to);
  from.setDate(to.getDate() - 6);
  return { from: toInputDate(from), to: toInputDate(to) };
}

export function getRangeBounds(key: RangeKey, now = new Date(), custom?: CustomDates): DateBounds {
  const today = startOfDay(now);
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  if (key === 'custom' && custom?.from && custom?.to) {
    const from = startOfDay(parseLocalDate(custom.from));
    const toExclusive = startOfDay(parseLocalDate(custom.to));
    toExclusive.setDate(toExclusive.getDate() + 1);
    if (toExclusive <= from) {
      const next = new Date(from);
      next.setDate(from.getDate() + 1);
      return { from, to: next };
    }
    return { from, to: toExclusive };
  }

  if (key === 'today') return { from: today, to: tomorrow };

  if (key === 'yesterday') {
    const from = new Date(today);
    from.setDate(today.getDate() - 1);
    return { from, to: today };
  }

  const from = new Date(today);
  from.setDate(today.getDate() - (key === '7d' ? 6 : 29));
  return { from, to: tomorrow };
}

export function filterByRange(visits: Visit[], bounds: DateBounds): Visit[] {
  const a = bounds.from.getTime();
  const b = bounds.to.getTime();
  return visits.filter((v) => {
    const t = new Date(v.createdAt).getTime();
    return t >= a && t < b;
  });
}
